module.exports = "<div class=\"recommendationProducts\">\r\n    <wow-rr-carousel ng-if=\"$ctrl.placement\" rr-placement=\"$ctrl.placement\" dynamic-placement-id=\"$ctrl.placement.placement_name\"></wow-rr-carousel>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/recommendation/recommendation-products.component.html
// module id = 344
// module chunks = 0 2